
export default [
    {
        id: 1,
        tiendaId: 0,
        tiendaNombre: "Desarrollo",
        codigoCaja: '001',
        areaId: 1,
        areaNombre: "Supermercado",
        monto: 1000000,
        estatus: true,
      },
      {
        id: 2,
        tiendaId: 0,
        tiendaNombre: "Desarrollo",
        codigoCaja: '002',
        areaId: 1,
        areaNombre: "Supermercado",
        monto: 200000,
        estatus: true,
      },
      {
        id: 3,
        tiendaId: 0,
        tiendaNombre: "Desarrollo",
        codigoCaja: '003',
        areaId: 1,
        areaNombre: "Supermercado",
        monto: 800000,
        estatus: true,
      }            
  ]
  